import { getMasterData } from "_services";
import { Heading } from "components";
import useDocumentTitle from "hooks/useDocumentTitle";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { StorageServices } from "utils";
import { LoadScript, Autocomplete } from '@react-google-maps/api';

const libraries = ['places'];

const Dashboard = () => {


  useDocumentTitle("Dashboard | MySifarish");
  useEffect(() => {
    fetchCategory();
  }, []);

  const fetchCategory = async (data) => {
    try {

      const res = await getMasterData({ appVersion: "1.0.0" });
      if (res) {
        StorageServices.setLocalItem('masterData', JSON.stringify(res?.data));
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  // console.log("dashboard", getMasterData)

  const [place, setPlace] = useState(null);
  const autocompleteRef = useRef(null);

  const onLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    if (autocompleteRef.current !== null) {
      const place = autocompleteRef.current.getPlace();
      setPlace(place);
    } else {
      console.log('Autocomplete not loaded');
    }
  };



  return (
    <React.Fragment>
      <Heading title={"Dashboard"} />
      <div className="_dashbord">
        <h5>Welcome to Admin Panel</h5>

        {/* <div>
          <LoadScript googleMapsApiKey="AIzaSyCkssBEyF60HLE5idQB9m5i407InVjjt-0" libraries={libraries}>
            <div style={{ padding: '20px' }}>
              <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                <input
                  type="text"
                  placeholder="Search for a place"
                  style={{
                    width: '100%',
                    height: '40px',
                    fontSize: '16px',
                    padding: '0 10px',
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                  }}
                />
              </Autocomplete>

              {place && (
                <div style={{ marginTop: '10px' }}>
                  <strong>Selected Place:</strong>
                  <pre>{JSON.stringify(place, null, 2)}</pre>
                </div>
              )}
            </div>
          </LoadScript>
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
